import classNames from 'classnames';
import styles from './ContentWrapper.module.css';

//#region [Props]
type ContentWrapperProps = {
    as?: React.ElementType;
    className?: string;
    children?: React.ReactNode;
} & React.HTMLAttributes<HTMLElement>;
//#endregion

//#region [Component]
// Export a component with CSS module class - maintains same API as styled component including 'as' prop
const SContentWrapper = ({ as: Component = 'div', className, ...props }: ContentWrapperProps) =>
    <Component className={classNames(styles.SContentWrapper, className)} {...props} />;

export default SContentWrapper;
//#endregion